import { render, staticRenderFns } from "./SpecialMenuHeader.vue?vue&type=template&id=39f7c6f3&scoped=true&"
import script from "./SpecialMenuHeader.vue?vue&type=script&lang=js&"
export * from "./SpecialMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./SpecialMenuHeader.vue?vue&type=style&index=0&id=39f7c6f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7c6f3",
  null
  
)

export default component.exports